import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fr8bot-privacy-policy-page',
  imports: [],
  templateUrl: './privacy-policy-page.html',
  styleUrl: './privacy-policy-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyPolicyPage {}
